import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ArrowRightIcon, ArrowDownIcon, SparklesIcon } from 'lucide-react';
export function TransformationSection() {
  return <section id="transformation" className="py-32 px-4 md:px-8 bg-cream-dark relative overflow-hidden" data-id="element-250">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-251">
        <FadeIn className="text-center mb-20" data-id="element-252">
          <h2 className="text-4xl md:text-5xl font-serif text-burgundy-dark" data-id="element-253">
            El cambio que te espera
          </h2>
        </FadeIn>

        <div className="flex flex-col md:flex-row items-stretch justify-center gap-8 md:gap-4 lg:gap-12" data-id="element-254">
          {/* Before */}
          <FadeIn direction="right" className="flex-1" data-id="element-255">
            <div className="h-full bg-white/80 backdrop-blur rounded-[2.5rem] shadow-sm border border-cream flex flex-col relative overflow-hidden grayscale-[0.3] opacity-90" data-id="element-256">
              <div className="absolute top-0 left-0 w-full h-2 bg-gray-300 z-10" data-id="element-257"></div>

              {/* Moody Image */}
              <img src="https://images.unsplash.com/photo-1515894203077-9cd36032142f?w=600&q=80" alt="Mujer acostada sola en la cama, de espaldas, evitando el contacto" className="w-full h-48 md:h-56 object-cover object-center grayscale-[0.4]" data-id="element-258" />

              <div className="p-10 md:p-12 flex flex-col justify-center flex-1" data-id="element-259">
                <span className="text-sm font-bold tracking-widest text-gray-400 uppercase mb-6 block" data-id="element-260">
                  Hoy
                </span>
                <p className="text-2xl md:text-3xl font-serif text-charcoal-light/80 leading-relaxed italic" data-id="element-261">
                  "Te acuestas de espaldas, fingiendo que duermes para evitar el
                  contacto."
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Animated Arrow */}
          <FadeIn delay={0.4} className="flex items-center justify-center py-6 md:py-0 relative" data-id="element-262">
            <motion.div animate={{
            scale: [1, 1.1, 1],
            opacity: [0.7, 1, 0.7]
          }} transition={{
            repeat: Infinity,
            duration: 2,
            ease: 'easeInOut'
          }} className="w-16 h-16 rounded-full bg-gradient-to-br from-gold to-rose flex items-center justify-center text-white shadow-lg relative z-10" data-id="element-263">
              <ArrowRightIcon className="hidden md:block w-8 h-8" data-id="element-264" />
              <ArrowDownIcon className="block md:hidden w-8 h-8" data-id="element-265" />
            </motion.div>
            <div className="hidden md:block absolute top-1/2 left-1/2 -translate-y-1/2 w-32 h-[2px] bg-gradient-to-r from-transparent via-gold to-transparent -z-0" data-id="element-266"></div>
          </FadeIn>

          {/* After */}
          <FadeIn direction="left" delay={0.2} className="flex-1" data-id="element-267">
            <div className="h-full bg-gradient-to-br from-rose-light to-cream rounded-[2.5rem] shadow-xl border border-rose/40 flex flex-col relative overflow-hidden" data-id="element-268">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold to-rose z-10" data-id="element-269"></div>

              {/* Sparkles */}
              <motion.div animate={{
              opacity: [0.2, 0.8, 0.2],
              scale: [0.8, 1.2, 0.8]
            }} transition={{
              repeat: Infinity,
              duration: 3,
              ease: 'easeInOut'
            }} className="absolute top-56 md:top-64 right-8 text-gold z-20" data-id="element-270">
                <SparklesIcon className="w-6 h-6" data-id="element-271" />
              </motion.div>

              {/* Warm Joyful Image */}
              <img src="https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=600&q=80" alt="Pareja feliz abrazándose con calidez y amor" className="w-full h-48 md:h-56 object-cover" data-id="element-272" />

              <div className="p-10 md:p-12 flex flex-col justify-center flex-1" data-id="element-273">
                <span className="text-sm font-bold tracking-widest text-gold-dark uppercase mb-6 block" data-id="element-274">
                  En 7 días
                </span>
                <p className="text-2xl md:text-3xl font-serif text-burgundy-dark leading-relaxed" data-id="element-275">
                  "Sientes una ligereza en el pecho, te miras al espejo y te
                  reconoces, y notas cómo él te busca con una mirada que no
                  veías hace años."
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}